import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import "../css/privacy.scss";

function CookiePolicy() {
  return (
    <main className="privacy-page">
      <header className="privacy-page__hero">
        <p>Legal</p>
        <h1>Cookie policy</h1>
        <div>
          <p>
            This policy explains how {siteConfig.brandName} uses cookies, local
            browser storage, and similar technologies on this storefront.
          </p>
          <p className="privacy-page__date">
            Last updated <time dateTime="2026-10-19">October 19, 2026</time>
          </p>
        </div>
      </header>

      <div className="privacy-page__layout">
        <aside>
          <nav aria-label="Cookie policy sections">
            <p>Contents</p>
            <a href="#cookie-technologies">Technologies</a>
            <a href="#cookie-essential">Essential storage</a>
            <a href="#cookie-optional">Optional technologies</a>
            <a href="#cookie-third-party">Third parties</a>
            <a href="#cookie-duration">Duration</a>
            <a href="#cookie-control">Your controls</a>
            <a href="#cookie-signals">Browser signals</a>
            <a href="#cookie-contact">Changes and contact</a>
          </nav>
        </aside>

        <article className="privacy-page__content">
          <section id="cookie-technologies" aria-labelledby="cookie-technologies-title">
            <span>01</span>
            <h2 id="cookie-technologies-title">Cookies and similar technologies</h2>
            <p>
              A cookie is a small text record placed through a browser. Local
              storage is a related browser feature that can retain information on
              your device without sending it with every page request. Similar
              technologies can also include pixels, software identifiers, and
              session storage.
            </p>
            <p>
              This storefront currently relies on essential local storage for
              shopping functions. We describe optional categories as well so the
              policy remains clear if a disclosed, consent-based tool is added.
            </p>
          </section>

          <section id="cookie-essential" aria-labelledby="cookie-essential-title">
            <span>02</span>
            <h2 id="cookie-essential-title">Essential browser storage</h2>
            <p>
              Essential storage keeps the shopping bag and wish list available on
              the same browser. The records are labeled
              <strong> jeautyfern-cart</strong> and
              <strong> jeautyfern-wishlist</strong>. They contain product
              identifiers and selected variants or quantities, not payment-card
              credentials.
            </p>
            <p>
              Checkout or payment providers may use their own strictly necessary
              cookies for security, load balancing, fraud prevention, and completion
              of the transaction. Their technologies are governed by their notices.
            </p>
          </section>

          <section id="cookie-optional" aria-labelledby="cookie-optional-title">
            <span>03</span>
            <h2 id="cookie-optional-title">Optional categories</h2>
            <p>If introduced, optional technologies may include:</p>
            <ul>
              <li>Preference tools that remember non-essential display or language choices.</li>
              <li>Analytics tools that measure visits, navigation, errors, and site performance.</li>
              <li>Advertising tools that measure campaigns or personalize advertising across services.</li>
            </ul>
            <p>
              Where consent is legally required, optional technologies will not be
              activated until a choice is made. This storefront is not currently
              configured for cross-context behavioral advertising.
            </p>
          </section>

          <section id="cookie-third-party" aria-labelledby="cookie-third-party-title">
            <span>04</span>
            <h2 id="cookie-third-party-title">Third-party services</h2>
            <p>
              Following a checkout or external-service link may take you to a
              provider that sets its own cookies. We do not control an independent
              provider's storage. Review the notice shown by the payment, wallet,
              carrier, or other service before making a choice.
            </p>
          </section>

          <section id="cookie-duration" aria-labelledby="cookie-duration-title">
            <span>05</span>
            <h2 id="cookie-duration-title">How long storage remains</h2>
            <p>
              Local bag and wish-list records remain until you remove them, clear
              site data, or browser settings remove them. Session technologies
              normally expire when the browser session ends. A third party sets its
              own retention period for technologies it controls.
            </p>
          </section>

          <section id="cookie-control" aria-labelledby="cookie-control-title">
            <span>06</span>
            <h2 id="cookie-control-title">Browser and consent controls</h2>
            <p>
              Browser settings can inspect, block, or delete cookies and site data.
              Private-browsing modes may delete storage when a session ends.
              Blocking essential storage can clear or prevent the bag, wish list,
              security checks, or checkout flow from working correctly.
            </p>
            <p>
              If a consent control is displayed, use it to revise optional choices.
              Clearing all browser data may also clear the saved consent record and
              require you to choose again.
            </p>
          </section>

          <section id="cookie-signals" aria-labelledby="cookie-signals-title">
            <span>07</span>
            <h2 id="cookie-signals-title">Do Not Track and opt-out signals</h2>
            <p>
              Because there is no single universal response standard for every
              browser signal, behavior can differ by technology and jurisdiction.
              Where applicable law requires recognition of a supported opt-out
              preference signal, we will process it as required. See our
              <Link to="/privacy-choices"> Privacy Choices</Link> notice.
            </p>
          </section>

          <section id="cookie-contact" aria-labelledby="cookie-contact-title">
            <span>08</span>
            <h2 id="cookie-contact-title">Changes and contact</h2>
            <p>
              We update this policy when browser storage or site services change.
              The date above identifies the current version. For cookie or privacy
              questions, email
              <a href={`mailto:${siteConfig.contact.email}`}> {siteConfig.contact.email}</a>.
            </p>
          </section>
        </article>
      </div>
    </main>
  );
}

export default CookiePolicy;
